import { StatesSelectComponent, StatesSelectProps } from '@common/components/state-select/states-select.component';
import { connect, Dispatch } from 'react-redux';
import { ControlProps } from 'react-redux-form';
import { AppState } from '../../..';
import { loadStates } from '@common/components/common.actions';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState, ownProps: ControlProps<HTMLSelectElement>): Partial<StatesSelectProps> {
  if (!state || !state.common) {
    return {
      controlProps: ownProps,
      statesOptions: []
    };
  }
  return {
    controlProps: ownProps,
    statesOptions: state.common.states || []
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: ControlProps<HTMLSelectElement>
): Partial<StatesSelectProps> {
  return {
    loadStates: () => {
      dispatch(loadStates());
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const StatesSelect = connect(
  mapStateToProps,
  mapDispatchToProps
)(StatesSelectComponent);



// WEBPACK FOOTER //
// ./src/common/components/state-select/states-select.container.ts